import { render, staticRenderFns } from "./SdLayerTree.vue?vue&type=template&id=4479cd48&scoped=true"
import script from "./SdLayerTree.vue?vue&type=script&lang=js"
export * from "./SdLayerTree.vue?vue&type=script&lang=js"
import style0 from "./SdLayerTree.vue?vue&type=style&index=0&id=4479cd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479cd48",
  null
  
)

export default component.exports